import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import LockIcon2 from '~/icons/components/LockIcon2';
import { LoyaltyTiers } from '~/shared/constants/loyaltyTiers';
import { ProductTag } from '~/shared/constants/products';
import { isLockedToMember } from '~/shared/utils/loyalty';
import { useLoyalty } from '~/techstyle-shared/react-accounts';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const LockedTreatmentContainer = styled.div`
  position: relative;
  overflow: hidden;
`;

const OverlayWrapper = styled.div`
  filter: contrast(0.3) brightness(1.5);
`;

const ExclusiveIndicator = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
`;

const LockIconWrapper = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  aspect-ratio: 1/1;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(5px);
`;

const UnlockText = styled.div`
  display: flex;
  padding: 8px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(5px);
  width: max-content;
`;

const ExclusiveLabel = styled.div`
  color: var(--Fab-Core-Colors-Shadow, #1b1c19);
  leading-trim: both;
  text-edge: cap;
  font-family: ${({ theme }) => theme.fontStacks.standardGtPressuraFamily};
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
`;

const ProductCardImageLockedTreatmentWrapper = ({
  tagIdList = [],
  children,
}) => {
  const { tier } = useLoyalty();
  const isProductPlatinumExclusive = tagIdList?.includes(
    Number(ProductTag.platinumExclusive)
  );

  const isLoyaltyLocked =
    isProductPlatinumExclusive &&
    isLockedToMember(tier?.label, LoyaltyTiers.PLATINUM);

  if (!isLoyaltyLocked) {
    return children;
  }

  return (
    <LockedTreatmentContainer>
      <OverlayWrapper>{children}</OverlayWrapper>
      <ExclusiveIndicator>
        <LockIconWrapper>
          <LockIcon2 />
        </LockIconWrapper>
        <UnlockText>
          <ExclusiveLabel>
            <FormattedMessage
              id="grid_static.platinum_exclusive"
              defaultMessage="Platinum Exclusive"
            />
          </ExclusiveLabel>
        </UnlockText>
      </ExclusiveIndicator>
    </LockedTreatmentContainer>
  );
};

ProductCardImageLockedTreatmentWrapper.propTypes = {
  children: PropTypes.node,
  tagIdList: PropTypes.array,
};

export default ProductCardImageLockedTreatmentWrapper;
